import baseApi, { TAGS } from './baseApi';

const researchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResearchParticipants: builder.query({
      query: ({ studySlug, search, limit = 50, offset = 0 }) => ({
        url: `research/studies/${studySlug}/participants`,
        method: 'GET',
        params: {
          ...(search ? { search } : {}),
          limit,
          offset
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: ({ participants = [] } = {}) => [
        ...participants.map(({ id }) => ({ type: TAGS.RESEARCH_PARTICIPANTS, id })),
        { type: TAGS.RESEARCH_PARTICIPANTS, id: 'LIST' }
      ]
    }),
    getResearchParticipantsByUser: builder.query({
      query: (userId) => ({
        url: 'research/participants',
        method: 'GET',
        params: { userId }
      }),
      transformResponse: (response) => response.data,
      providesTags: (participants = []) => [
        ...participants.map(({ id }) => ({ type: TAGS.RESEARCH_PARTICIPANTS, id })),
        { type: TAGS.RESEARCH_PARTICIPANTS, id: 'LIST' }
      ]
    }),
    updateResearchParticipantStatus: builder.mutation({
      query: ({ studySlug, participantId, status, revisionNotes }) => ({
        url: `research/studies/${studySlug}/participants/${participantId}/status`,
        method: 'PATCH',
        body: { status, ...(revisionNotes !== undefined ? { revisionNotes } : {}) }
      }),
      extraOptions: { maxRetries: 0 },
      invalidatesTags: (_result, _error, { participantId }) => [
        { type: TAGS.RESEARCH_PARTICIPANTS, id: participantId },
        { type: TAGS.RESEARCH_PARTICIPANTS, id: 'LIST' }
      ]
    }),
    clearResearchParticipant: builder.mutation({
      query: ({ studySlug, participantId }) => ({
        url: `research/studies/${studySlug}/participants/${participantId}`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 0 },
      invalidatesTags: (_result, _error, { participantId }) => [
        { type: TAGS.RESEARCH_PARTICIPANTS, id: participantId },
        { type: TAGS.RESEARCH_PARTICIPANTS, id: 'LIST' }
      ]
    }),
    deleteResearchWorkFile: builder.mutation({
      query: ({ studySlug, participantId, fileId }) => ({
        url: `research/studies/${studySlug}/participants/${participantId}/work-files/${fileId}`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 0 },
      invalidatesTags: (_result, _error, { participantId }) => [
        { type: TAGS.RESEARCH_PARTICIPANTS, id: participantId },
        { type: TAGS.RESEARCH_PARTICIPANTS, id: 'LIST' }
      ]
    }),
    getResearchFileDownloadUrl: builder.query({
      query: ({ studySlug, participantId, fileId }) => ({
        url: `research/studies/${studySlug}/participants/${participantId}/files/${fileId}/download-url`,
        method: 'GET'
      }),
      transformResponse: (response) => response.data
    })
  })
});

export const {
  useClearResearchParticipantMutation,
  useDeleteResearchWorkFileMutation,
  useGetResearchParticipantsQuery,
  useGetResearchParticipantsByUserQuery,
  useUpdateResearchParticipantStatusMutation,
  useLazyGetResearchFileDownloadUrlQuery
} = researchApi;
